import { Fragment } from 'react';

/**
 * Return ellipsis of a given string
 * @param {string} text
 * @param {number} size
 */
const capitalizeFirst = (string) => {
  if (typeof string === 'string') {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return '';
};

const ellipsis = (text, size) => {
  return `${text.split(' ').slice(0, size).join(' ')}...`;
};

const rupiahFormat = (number, withPrefix = true) => {
  number = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(number);

  if (!withPrefix) {
    number = number.replace('Rp', '');
  }

  return number;
};

const rupiahToInt = (string) => {
  return parseInt(string.replaceAll('Rp', '').replaceAll('.', ''));
};

const numberFormat = (number) => {
  return new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(number);
};

const abbrevNumber = (n, decimal = 2) => {
  const isNegative = n < 0; // Check if the number is negative
  n = Math.abs(n); // Work with the absolute value of the number

  if (n < 1e3) return `${isNegative ? '-' : ''}${n.toFixed(decimal)}`;
  if (n >= 1e3 && n < 1e6) return `${isNegative ? '-' : ''}${(n / 1e3).toFixed(0)} Rb`;
  if (n >= 1e6 && n < 1e9) return `${isNegative ? '-' : ''}${(n / 1e6).toFixed(decimal)} Jt`;
  if (n >= 1e9 && n < 1e12) return `${isNegative ? '-' : ''}${(n / 1e9).toFixed(decimal)} M`;
  if (n >= 1e12) return `${isNegative ? '-' : ''}${(n / 1e12).toFixed(decimal)} T`;
};
function nl2br(str) {
  return str.split('\n').map((item, key) => {
    return (
      <Fragment key={key}>
        {item}
        <br />
      </Fragment>
    );
  });
}

function toKebabCase(str) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2') // handle camelCase
    .replace(/[\s_]+/g, '-') // spaces and underscores to dashes
    .replace(/[^a-zA-Z0-9-]/g, '') // remove non-alphanumeric except dashes
    .toLowerCase();
}

function appendFormData(formData, data, parentKey = null) {
  if (data === null || data === undefined) {
    formData.append(parentKey, '');
    return;
  }

  if (Array.isArray(data)) {
    data.forEach((value, index) => {
      const key = parentKey ? `${parentKey}[${index}]` : index;
      appendFormData(formData, value, key);
    });
  } else if (typeof data === 'object' && !(data instanceof File)) {
    Object.entries(data).forEach(([key, value]) => {
      const newKey = parentKey ? `${parentKey}[${key}]` : key;
      appendFormData(formData, value, newKey);
    });
  } else {
    formData.append(parentKey, data);
  }
}

function getHumanReadableDuration(startDatetime) {
  const moment = require('moment');
  const duration = moment.duration(moment().diff(moment(startDatetime)));
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();

  let breakdownTimeText = '';
  if (days > 0) {
    breakdownTimeText = `${days} hari ${hours} jam`;
  } else if (hours > 0) {
    breakdownTimeText = `${hours} jam ${minutes} menit`;
  } else {
    breakdownTimeText = `${minutes} menit`;
  }

  return breakdownTimeText;
}

export { capitalizeFirst, ellipsis, rupiahFormat, numberFormat, abbrevNumber, nl2br, rupiahToInt, toKebabCase, appendFormData, getHumanReadableDuration };
